import React from 'react';
import ImgAdd from './img-add.png';
import SandeTableList from './SandeTableList';
import addNewSandTable from '../actions/addNewSandTable';

function SandTableBar() {
  return (
    <div className="mt-10 flex h-100 select-none">
      <div className="mr-10 flex-1 rounded bg-black-#28 p-10">
        <SandeTableList />
      </div>
      <div
        className="flex h-full w-90 flex-shrink-0 cursor-pointer flex-col items-center justify-center rounded bg-black-#28 hover:bg-black-#34"
        onClick={addNewSandTable}
      >
        <img src={ImgAdd} className="mb-5 h-24 w-24" alt="" />
        <div>创建沙盘</div>
      </div>
    </div>
  );
}

export default SandTableBar;
